var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.shouldShow
      ? _c(
          "div",
          {
            staticClass: "session-timeout-renew-overlay",
            attrs: {
              role: "dialog",
              "aria-modal": "true",
              "aria-labelledby": "session-timeout-renew-title"
            }
          },
          [
            _c("div", { staticClass: "session-timeout-renew-card" }, [
              _c(
                "h5",
                {
                  staticClass: "session-timeout-renew-title",
                  attrs: { id: "session-timeout-renew-title" }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("session_timeout.warning_title")) + " "
                  )
                ]
              ),
              _c("div", { staticClass: "session-timeout-renew" }, [
                _c(
                  "div",
                  { staticClass: "renew-icon" },
                  [
                    _c("feather-icon", {
                      attrs: { icon: "AlertCircleIcon", size: "36" }
                    })
                  ],
                  1
                ),
                _c("p", { staticClass: "renew-message" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("session_timeout.warning_message")) +
                      " "
                  )
                ]),
                _c("p", { staticClass: "renew-countdown" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("session_timeout.remaining", {
                          time: _vm.formattedTime
                        })
                      ) +
                      " "
                  )
                ])
              ]),
              _c("div", { staticClass: "session-timeout-renew-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.continueSession($event)
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("session_timeout.renew")) + " ")]
                )
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }